import { useState } from "react"
import { useNavigate } from "react-router-dom"
import routes from "../constants/routes"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import TabPanel from "../components/ui/TabPanel"
import Sessions from "../components/admin/Sessions"
import Events from "../components/admin/Events"
import StudentsTab from "../components/course/StudentsTab"
import { Stack } from "@mui/material"
import TabLogo from "../components/common/TabLogo"
import Faculty from "../components/admin/Faculty"
import Staff from "../components/admin/Staff"
import Institutions from "../components/admin/Institutions"

const Admin = ({ tab }) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    switch (newValue) {
      case 0:
        navigate(routes.ADMIN.SESSION, { replace: true })
        break
      case 1:
        navigate(routes.ADMIN.ADMISSION, { replace: true })
        break
      case 2:
        navigate(routes.ADMIN.INSTITUTE, { replace: true })
        break
      case 3:
        navigate(routes.ADMIN.STUDENTS, { replace: true })
        break
      case 4:
        navigate(routes.ADMIN.FACULTIES, { replace: true })
        break
      case 5:
        navigate(routes.ADMIN.STAFFS, { replace: true })
        break
      default:
        navigate(routes.ADMIN.SESSION, { replace: true })
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction="row" sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabLogo />
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Academic Session" />
          <Tab label="Admission" />
          <Tab label="Institute" />
          <Tab label="Students" />
          <Tab label="Faculties" />
          <Tab label="Staffs" />
        </Tabs>
      </Stack>
      <TabPanel value={value} index={0}>
        <Sessions />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Events />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Institutions />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <StudentsTab />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Faculty />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Staff />
      </TabPanel>
    </Box>
  )
}

export default Admin
